import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { SearchFieldComponent } from 'src/app/base/shared/search-field/search-field.component';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { ThirdPartyUserAssignmentAdministrationService } from './third-party-user-assignment-administration.service';
import { DataManager } from '@syncfusion/ej2-data';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ThirdPartyUserAssignmentEditDialogComponent } from './third-party-user-assignment-edit-dialog/third-party-user-assignment-edit-dialog.component';

@Component({
  selector: 'app-third-party-user-assignment-administration',
  templateUrl: './third-party-user-assignment-administration.component.html',
  styleUrls: ['./third-party-user-assignment-administration.component.scss'],
  standalone: true,
  imports: [TitleBarComponent, SearchFieldComponent, /*CheckBoxModule,*/ GridModule, ToolbarModule, TranslateModule, ThirdPartyUserAssignmentEditDialogComponent],
})
export class ThirdPartyUserAssignmentAdministrationComponent extends GridBaseComponent implements OnInit {
  @ViewChild(ThirdPartyUserAssignmentEditDialogComponent) public editDialog: ThirdPartyUserAssignmentEditDialogComponent;

  public zonePathFieldName = this.assignmentService.extendedZonePathFieldName;

  public override gridCommands = [
        {
          type: SfCommandButtonType.Delete,
          buttonOption:
          {
            cssClass: 'icon-btn',
            iconCss: 'icon-trash-can e-icons e-danger'
          }
        }];

  public override onAdd() {
    this.editDialog.openDialog(true);
  }

  public onBulkDelete() {
    this.editDialog.openDialog(false);
  }

  constructor(translateService: TranslateService, private assignmentService: ThirdPartyUserAssignmentAdministrationService, private spinnerService: SpinnerService) {
    super(null, translateService, assignmentService);
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.assignmentService, this.spinnerService),
    });
    this.searchOptions = {fields: ['user.userName', 'client.name', 'zone.name']};
  }

  public onRefreshData() {
    this.grid.refresh();
  }

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected override getEditDialogTitleParams(rowData: any) {
    throw new Error('Method not implemented.');
  }

}
